// import React from "react";
// import api from "../../utils/api";
// import { useState, useEffect } from "react";
// import PreferenceFormFilled from "../pages/PreferenceFormFilled";
// import { Navigate } from "react-router-dom";

// export default function PreferenceForm() {
//   //to get titles of projects for the dropdown
//   const [details, setDetails] = useState([]);
//   const [userPreference, setUserPreference] = useState([]);
//   const [page, setPage] = useState(1);
//   const [submitted, setSubmitted] = useState(false);
//   const [error, setError] = useState(false);
//   const [error1, setError1] = useState(false);

//   useEffect(() => {
//     // Make an HTTP request to fetch the card image from the backend
//     api
//       .get(process.env.REACT_APP_BACKEND_URL + "/projects/wishlist/")
//       .then((response) => {
//         // Assuming the response contains the image URL
//         console.log(response.data);
//         setDetails(response.data);
//         setSubmitted(false);
//       })
//       .catch((error) => {
//         console.error("Error fetching card image:", error);
//       });
//   }, []);

//   useEffect(() => {
//     // Make an HTTP request to fetch the card image from the backend
//     api
//       .get(process.env.REACT_APP_BACKEND_URL + "/projects/preference")
//       .then((response) => {
//         // Assuming the response contains the image URL
//         console.log(response.data);
//         setUserPreference(response.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching card image:", error);
//       });
//   }, []);

//   const [data1, setData1] = useState({
//     project: "",
//     sop: "",
//     preference: 1,
//   });
//   const [data2, setData2] = useState({
//     project: "",
//     sop: "",
//     preference: 2,
//   });
//   const [data3, setData3] = useState({
//     project: "",
//     sop: "",
//     preference: 3,
//   });

//   if (userPreference.length > 0) {
//     return <Navigate to="/PreferenceFormFilled" />;
//   }
//   const dataChange1 = (e) => {
//     const { id, value } = e.target;
//     setData1({
//       ...data1,
//       [id]: value,
//       // console.log(projectlist)
//     });
//     setSubmitted(false);
//     console.log("id:", id);
//     console.log("value:", value);
//     console.log(data1);
//   };
//   const dataChange2 = (e) => {
//     const { id, value } = e.target;
//     setData2({
//       ...data2,
//       [id]: value,
//       // console.log(projectlist)
//     });
//     setSubmitted(false);
//     console.log("id:", id);
//     console.log("value:", value);
//     console.log(data2);
//   };
//   const dataChange3 = (e) => {
//     const { id, value } = e.target;
//     setData3({
//       ...data3,
//       [id]: value,
//       // console.log(projectlist)
//     });
//     setSubmitted(false);
//     console.log("id:", id);
//     console.log("value:", value);
//     console.log(data3);
//   };

//   const handleSubmit = (e) => {
//     console.log(data1);
//     console.log(data2);
//     console.log(data3);
//     e.preventDefault();
//     if (
//       data1.project === "" ||
//       data1.sop === "" ||
//       data2.project === "" ||
//       data2.sop === "" ||
//       data3.project === "" ||
//       data3.sop === ""
//     ) {
//       setError(true);
//     } else if (
//       data1.project === data2.project ||
//       data1.project === data3.project ||
//       data3.project === data2.project
//     ) {
//       setError1(true);
//     } else {
//       setSubmitted(true);
//       setError(false);

//       const formData1 = new FormData();
//       Object.keys(data1).forEach((key) => {
//         formData1.append(key, data1[key]);
//       });
//       const formData2 = new FormData();
//       Object.keys(data2).forEach((key) => {
//         formData2.append(key, data2[key]);
//       });
//       const formData3 = new FormData();
//       Object.keys(data3).forEach((key) => {
//         formData3.append(key, data3[key]);
//       });

//       api
//         .post(
//           process.env.REACT_APP_BACKEND_URL + "/projects/preference/",
//           formData1
//         )
//         .then((res) => {
//           console.log(res);
//         })
//         .catch((err) => {
//           console.log(err);
//           setError(true);
//         });
//       api
//         .post(
//           process.env.REACT_APP_BACKEND_URL + "/projects/preference/",
//           formData2
//         )
//         .then((res) => {
//           console.log(res);
//         })
//         .catch((err) => {
//           console.log(err);
//           setError(true);
//         });
//       api
//         .post(
//           process.env.REACT_APP_BACKEND_URL + "/projects/preference/",
//           formData3
//         )
//         .then((res) => {
//           console.log(res);
//           setSubmitted(true);
//         })
//         .catch((err) => {
//           console.log(err);
//           setError(true);
//         });
//     }
//   };

//   if (submitted) {
//     return <Navigate to="/PreferenceFormFilled" />;
//   }

//   const successMessage = () => {
//     return (
//       <>
//         <div
//           className="success dark:bg-gray-800 dark:text-white"
//           style={{
//             display: submitted ? "" : "none",
//           }}
//         >
//           <div
//             role="alert"
//             className="rounded-xl border border-gray-100 bg-white p-4"
//           >
//             <div className="flex items-start gap-4">
//               <span className="text-green-600">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   strokeWidth="1.5"
//                   stroke="currentColor"
//                   className="h-6 w-6"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//                   />
//                 </svg>
//               </span>

//               <div className="flex-1">
//                 <strong className="block font-medium text-gray-900">
//                   {" "}
//                   Thank You{" "}
//                 </strong>

//                 <p className="mt-1 text-sm text-gray-700">
//                   You have successfully filled the form.
//                 </p>
//               </div>

//               <button className="text-gray-500 transition hover:text-gray-600">
//                 <span className="sr-only">Dismiss popup</span>

//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   strokeWidth="1.5"
//                   stroke="currentColor"
//                   className="h-6 w-6"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     d="M6 18L18 6M6 6l12 12"
//                   />
//                 </svg>
//               </button>
//             </div>
//           </div>
//         </div>
//       </>
//     );
//   };

//   function ErrorPopup({ message, onClose }) {
//     if (!message) return null;

//     return (
//       <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
//         <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg max-w-sm text-center">
//           <div className="text-red-600 dark:text-red-400 mb-2">
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               viewBox="0 0 24 24"
//               fill="currentColor"
//               className="w-12 h-12 mx-auto"
//             >
//               <path
//                 fillRule="evenodd"
//                 d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z"
//                 clipRule="evenodd"
//               />
//             </svg>
//           </div>
//           <p className="text-lg font-semibold text-gray-800 dark:text-white">
//             {message}
//           </p>
//           <button
//             onClick={onClose}
//             className="mt-4 px-4 py-2 bg-indigo-600 text-white rounded-lg"
//           >
//             OK
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <>
//       <div className="form h-[calc(100vh-72px)] dark:bg-gray-800 dark:text-white">
//         {/* Calling to the methods */}
//         <div className="messages">
//         {error && <ErrorPopup message={"All fields are Required"} onClose={() => setError(false)} />}
//         {error1 && (
//           <ErrorPopup message={"Cannot Repeat Preferences."} onClose={() => setError1(false)} />
//         )}
//           {successMessage()}
//         </div>

//         <div className="mx-auto max-w-screen-xl px-4 py-16 sm:px-6 lg:px-8">
//           <div className="mx-auto max-w-lg">
//             <h1 className="text-center text-2xl font-bold text-indigo-600 sm:text-3xl flex items-center justify-center">
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 fill="none"
//                 viewBox="0 0 24 24"
//                 strokeWidth={1.5}
//                 stroke="currentColor"
//                 className="w-10 h-10"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   d="M17.25 6.75 22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3-4.5 16.5"
//                 />
//               </svg>
//               <span className="mx-3">Seasons of Code</span>
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 fill="none"
//                 viewBox="0 0 24 24"
//                 strokeWidth={1.5}
//                 stroke="currentColor"
//                 className="w-10 h-10"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   d="M17.25 6.75 22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3-4.5 16.5"
//                 />
//               </svg>
//             </h1>

//             <form className="mb-0 mt-6 space-y-4 rounded-lg p-4 shadow-2xl sm:p-6 lg:p-8">
//               <p className="text-center text-lg font-medium">Preference Form</p>
//               {page === 1 && (
//                 <Page2
//                   project={data1.project}
//                   sop={data1.sop}
//                   dataChange={dataChange1}
//                   setPage={setPage}
//                   details={details}
//                 />
//               )}
//               {page === 2 && (
//                 <Page3
//                   project={data2.project}
//                   sop={data2.sop}
//                   dataChange={dataChange2}
//                   setPage={setPage}
//                   details={details}
//                 />
//               )}
//               {page === 3 && (
//                 <Page4
//                   project={data3.project}
//                   sop={data3.sop}
//                   dataChange={dataChange3}
//                   setPage={setPage}
//                   details={details}
//                   handleSubmit={handleSubmit}
//                 />
//               )}
//             </form>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// const Page2 = ({ project, sop, dataChange, setPage, details }) => {
//   return (
//     <>
//       <div className="inline-block relative w-full">
//         <label htmlFor="project" className="block text-sm font-medium">
//           {" "}
//           Project 1{" "}
//         </label>

//         <select
//           id="project"
//           name="project"
//           className="w-full rounded-lg border-gray-200 p-4 pe-12 text-sm shadow-sm  dark:bg-gray-800 "
//           onChange={dataChange}
//           value={project}
//           required
//         >
//           <option value="">Please select</option>
//           {details.map((details, index) => (
//             <option key={index} value={details.id}>
//               {`Project ID: ${details.id} ${details.title}`}
//             </option>
//           ))}
//         </select>
//       </div>

//       <div>
//         <label htmlFor="sop" className="block text-sm font-medium">
//           Statement of Purpose
//         </label>

//         <textarea
//           id="sop"
//           className="mt-2 w-full rounded-lg border-gray-200 p-4 pe-12 align-top shadow-sm sm:text-sm  dark:bg-gray-800 "
//           rows="4"
//           placeholder="Write your SOP here..."
//           required
//           value={sop}
//           onChange={dataChange}
//           aria-required
//         ></textarea>
//       </div>
//       <button
//         type="submit"
//         className="block w-full rounded-lg bg-indigo-600 px-5 py-3 text-sm font-medium text-white flex items-center justify-center"
//         onClick={() => setPage(2)}
//       >
//         Next
//         <svg
//           xmlns="http://www.w3.org/2000/svg"
//           fill="none"
//           viewBox="0 0 24 24"
//           strokeWidth={1.5}
//           stroke="currentColor"
//           className="w-6 h-6"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             d="m8.25 4.5 7.5 7.5-7.5 7.5"
//           />
//         </svg>
//       </button>
//     </>
//   );
// };
// const Page3 = ({ project, sop, dataChange, setPage, details }) => {
//   return (
//     <>
//       <div className="inline-block relative w-full">
//         <label htmlFor="project" className="block text-sm font-medium">
//           {" "}
//           Project 2{" "}
//         </label>

//         <select
//           id="project"
//           name="project"
//           className="w-full rounded-lg border-gray-200 p-4 pe-12 text-sm shadow-sm  dark:bg-gray-800 "
//           onChange={dataChange}
//           value={project}
//           required
//         >
//           <option value="">Please select</option>
//           {details.map((details, index) => (
//             <option key={index} value={details.id}>
//               {`Project ID: ${details.id} ${details.title}`}
//             </option>
//           ))}
//         </select>
//       </div>

//       <div>
//         <label htmlFor="sop" className="block text-sm font-medium">
//           Statement of Purpose
//         </label>

//         <textarea
//           id="sop"
//           className="mt-2 w-full rounded-lg border-gray-200 p-4 pe-12 align-top shadow-sm sm:text-sm  dark:bg-gray-800 "
//           rows="4"
//           placeholder="Write your SOP here..."
//           required
//           value={sop}
//           onChange={dataChange}
//         ></textarea>
//       </div>

//       <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-8">
//         <button
//           type="submit"
//           className="block w-full rounded-lg bg-indigo-600 px-5 py-3 text-sm font-medium text-white flex items-center justify-center"
//           onClick={() => setPage(1)}
//         >
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             fill="none"
//             viewBox="0 0 24 24"
//             strokeWidth={1.5}
//             stroke="currentColor"
//             className="w-6 h-6"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               d="M15.75 19.5 8.25 12l7.5-7.5"
//             />
//           </svg>
//           Prev
//         </button>
//         <button
//           type="submit"
//           className="block w-full rounded-lg bg-indigo-600 px-5 py-3 text-sm font-medium text-white flex items-center justify-center"
//           onClick={() => setPage(3)}
//         >
//           Next
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             fill="none"
//             viewBox="0 0 24 24"
//             strokeWidth={1.5}
//             stroke="currentColor"
//             className="w-6 h-6"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               d="m8.25 4.5 7.5 7.5-7.5 7.5"
//             />
//           </svg>
//         </button>
//       </div>
//     </>
//   );
// };
// const Page4 = ({
//   project,
//   sop,
//   dataChange,
//   setPage,
//   details,
//   handleSubmit,
// }) => {
//   return (
//     <>
//       <div className="inline-block relative w-full">
//         <label htmlFor="project" className="block text-sm font-medium">
//           {" "}
//           Project 3{" "}
//         </label>

//         <select
//           id="project"
//           name="project"
//           className="w-full rounded-lg border-gray-200 p-4 pe-12 text-sm shadow-sm  dark:bg-gray-800 "
//           onChange={dataChange}
//           value={project}
//           required
//         >
//           <option value="">Please select</option>
//           {details.map((details, index) => (
//             <option key={index} value={details.id}>
//               {`Project ID: ${details.id} ${details.title}`}
//             </option>
//           ))}
//         </select>
//       </div>

//       <div>
//         <label htmlFor="sop" className="block text-sm font-medium">
//           Statement of Purpose
//         </label>

//         <textarea
//           id="sop"
//           className="mt-2 w-full rounded-lg border-gray-200 p-4 pe-12 align-top shadow-sm sm:text-sm  dark:bg-gray-800 "
//           rows="4"
//           placeholder="Write your SOP here..."
//           required
//           value={sop}
//           onChange={dataChange}
//         ></textarea>
//       </div>
//       <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-8">
//         <button
//           type="submit"
//           className="block w-full rounded-lg bg-indigo-600 px-5 py-3 text-sm font-medium text-white flex items-center justify-center"
//           onClick={() => setPage(2)}
//         >
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             fill="none"
//             viewBox="0 0 24 24"
//             strokeWidth={1.5}
//             stroke="currentColor"
//             className="w-6 h-6"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               d="M15.75 19.5 8.25 12l7.5-7.5"
//             />
//           </svg>
//           Prev
//         </button>
//         <button
//           type="submit"
//           className="block w-full rounded-lg bg-indigo-600 px-5 py-3 text-sm font-medium text-white"
//           onClick={handleSubmit}
//         >
//           Submit
//         </button>
//       </div>
//     </>
//   );
// };

import React, { useState, useEffect } from 'react';
import { Navigate, useParams, useNavigate } from 'react-router-dom';
import api from '../../utils/api';

export default function PreferenceForm() {
  const [details, setDetails] = useState([]);
  const [userPreference, setUserPreference] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const { domain } = useParams();
  const navigate = useNavigate();
  const [domainSettings, setDomainSettings] = useState({ max_preferences: 3, mentee_portal_access: true });
  const [data, setData] = useState([]);

  useEffect(() => {
    const endpoint = domain
      ? `${process.env.REACT_APP_BACKEND_URL}/projects/wishlist/?domain=${domain}`
      : `${process.env.REACT_APP_BACKEND_URL}/projects/wishlist/`;
    
    api
      .get(endpoint)
      .then((response) => setDetails(response.data))
      .catch((error) => console.error('Error fetching projects:', error));
  }, [domain]);

  // Fetch domain settings to get max_preferences
  useEffect(() => {
    if (domain) {
      api.get(`${process.env.REACT_APP_BACKEND_URL}/domains/${domain}/`)
        .then((response) => {
          setDomainSettings(response.data);
          // Initialize data array based on max_preferences
          const maxPrefs = response.data.max_preferences || 3;
          const initialData = Array.from({ length: maxPrefs }, (_, i) => ({
            project: '',
            sop: '',
            preference: i + 1
          }));
          setData(initialData);
        })
        .catch((error) => {
          console.error('Error fetching domain settings:', error);
          // Fallback to 3 preferences
          setData([
            { project: '', sop: '', preference: 1 },
            { project: '', sop: '', preference: 2 },
            { project: '', sop: '', preference: 3 },
          ]);
        });
    } else {
      // Default to 3 preferences if no domain
      setData([
        { project: '', sop: '', preference: 1 },
        { project: '', sop: '', preference: 2 },
        { project: '', sop: '', preference: 3 },
      ]);
    }
  }, [domain]);

  useEffect(() => {
    const endpoint = domain
      ? `${process.env.REACT_APP_BACKEND_URL}/projects/preference/?domain=${domain}`
      : `${process.env.REACT_APP_BACKEND_URL}/projects/preference`;
    
    api
      .get(endpoint)
      .then((response) => setUserPreference(response.data))
      .catch((error) => console.error('Error fetching preferences:', error));
  }, [domain]);

  if (userPreference.length > 0) {
    return <Navigate to={domain ? `/${domain}/PreferenceFormFilled` : '/PreferenceFormFilled'} />;
  }

  if (!domainSettings.mentee_portal_access) {
    return (
      <div className="form min-h-[calc(100vh-72px)] dark:bg-gray-800 dark:text-white">
        <div className="flex items-center justify-center min-h-[calc(100vh-72px)]">
          <div className="text-center p-8 bg-white dark:bg-gray-900 rounded-lg shadow-lg max-w-md">
            <div className="text-6xl mb-4">🔒</div>
            <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-2">Mentee Portal Closed</h2>
            <p className="text-gray-600 dark:text-gray-400 mb-4">
              The mentee portal for this domain is currently not accessible. Please check back later or contact the domain manager.
            </p>
            <button
              onClick={() => navigate('/')}
              className="px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
            >
              Go to Home
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (submitted) {
    window.location.href = domain ? `/${domain}/PreferenceFormFilled` : '/PreferenceFormFilled';
    return null;
  }

  const handleSubmit = () => {
    setErrorMsg('');
    
    // Filter out empty preferences
    const filledPrefs = data.filter(d => d.project || d.sop);
    
    // Validation
    if (filledPrefs.length === 0) {
      setErrorMsg('At least one preference must be filled.');
      return;
    }
    
    for (let pref of filledPrefs) {
      if (pref.project && !pref.sop.trim()) {
        setErrorMsg('Project selected but SOP is missing.');
        return;
      }
      if (!pref.project && pref.sop.trim()) {
        setErrorMsg('SOP filled but project is not selected.');
        return;
      }
    }
    
    // Check for duplicate projects
    const projectIds = filledPrefs.map(p => p.project);
    if (new Set(projectIds).size !== projectIds.length) {
      setErrorMsg('Cannot select the same project multiple times.');
      return;
    }
    
    // Submit only filled preferences
    const submitPromises = filledPrefs.map((pref) => {
      const formData = new FormData();
      formData.append('project', pref.project);
      formData.append('sop', pref.sop);
      formData.append('preference', pref.preference);
      if (domain) formData.append('domain', domain);
      return api.post(`${process.env.REACT_APP_BACKEND_URL}/projects/preference/`, formData);
    });
    
    Promise.all(submitPromises)
      .then(() => setSubmitted(true))
      .catch((err) => {
        console.error(err);
        setErrorMsg(err.response?.data?.error || 'Failed to submit preferences.');
      });
  };

  return (
    <div className="form min-h-[calc(100vh-72px)] dark:bg-gray-800 dark:text-white">
      {/* Quick Navigation Bar */}
      <div className="bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700 py-3 px-6">
        <div className="max-w-screen-xl mx-auto flex gap-4">
          <button
            onClick={() => navigate(domain ? `/${domain}/current_projects` : '/current_projects')}
            className="px-4 py-2 text-sm font-medium bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
          >
            Projects
          </button>
          <button
            onClick={() => navigate(domain ? `/${domain}/wishlist` : '/wishlist')}
            className="px-4 py-2 text-sm font-medium bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-200 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
          >
             Wishlist
          </button>
          <button
            onClick={() => navigate(domain ? `/${domain}/PreferenceForm` : '/PreferenceForm')}
            className="px-4 py-2 text-sm font-medium bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
          >
             Preferences
          </button>
        </div>
      </div>

      <div className="mx-auto max-w-screen-xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl">
          <h1 className="text-center text-2xl font-bold text-indigo-600 sm:text-3xl mb-6">
            Preference Form
          </h1>
          <p className="text-center text-sm text-gray-600 dark:text-gray-400 mb-8">
            Fill at least 1 preference (maximum {domainSettings.max_preferences || 3} allowed).
          </p>

          {errorMsg && (
            <div className="mb-4 p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg">
              <p className="text-red-600 dark:text-red-400 text-sm">{errorMsg}</p>
            </div>
          )}

          <div className="space-y-6">
            {data.map((_, num) => (
              <PreferenceCard
                key={num}
                num={num + 1}
                data={data}
                setData={setData}
                details={details}
              />
            ))}
          </div>

          <button
            onClick={handleSubmit}
            className="mt-8 w-full rounded-lg bg-indigo-600 px-5 py-3 text-sm font-medium text-white hover:bg-indigo-700"
          >
            Submit Preferences
          </button>
        </div>
      </div>
    </div>
  );
}

const PreferenceCard = ({ num, data, setData, details }) => {
  const selectedProjects = data.map(d => d.project).filter(p => p);
  
  const handleProjectChange = (e) => {
    const newData = [...data];
    newData[num - 1].project = e.target.value;
    setData(newData);
  };

  const handleSOPChange = (e) => {
    const newData = [...data];
    newData[num - 1].sop = e.target.value;
    setData(newData);
  };

  const availableProjects = details.filter(
    (p) => !selectedProjects.includes(p.id.toString()) || p.id.toString() === data[num - 1].project
  );

  return (
    <div className="p-6 bg-white dark:bg-gray-900 rounded-lg shadow-md border border-gray-200 dark:border-gray-700">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        Preference {num} {num === 1 && <span className="text-red-500">*</span>}
      </h3>
      
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Select Project
          </label>
          <select
            className="w-full rounded-lg border-gray-300 dark:border-gray-600 p-3 text-sm shadow-sm dark:bg-gray-800 dark:text-white"
            onChange={handleProjectChange}
            value={data[num - 1].project}
          >
            <option value="">-- Select a project (optional) --</option>
            {availableProjects.map(({ id, title }) => (
              <option key={id} value={id}>
                {title}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Statement of Purpose
          </label>
          <textarea
            className="w-full rounded-lg border-gray-300 dark:border-gray-600 p-3 shadow-sm dark:bg-gray-800 dark:text-white"
            rows="4"
            placeholder="Explain why you want to work on this project..."
            value={data[num - 1].sop}
            onChange={handleSOPChange}
          />
        </div>
      </div>
    </div>
  );
}
